import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegmentationForm, useSegmentationFormActions } from '../_form/SegmentationFormHandler'
import AssetsCardPicker from '../../../../containers/assets/cardPicker/AssetsCardPicker'

export const useAssetStepDef = () => {
  const form = useSegmentationForm()
  const { t } = useTranslation('editSegmentation')

  return useMemo(
    () => ({
      title: 'assetStep.title',
      subtitle: 'assetStep.subtitle',
      Component: AssetStep,
      validate: () => {
        if (!form?.assets?.length) return [false, t('assetStep.validation.selectAsset')]
        return [true]
      }
    }),
    [form?.assets?.length, t]
  )
}

const AssetStep = () => {
  const form = useSegmentationForm()
  const { handleChange } = useSegmentationFormActions()

  return (
    <AssetsCardPicker
      ignoreSegments
      idField="id"
      value={form?.assets}
      onChange={handleChange('assets')}
      multiple
      useSelectAll
    />
  )
}

export default AssetStep
